<template>
  <v-row>
    <v-col cols="3" v-for="item in items" :key="item.key">
      <v-card
        :style="{ backgroundColor: item.bg }"
        class="pa-4 text-center"
        flat
      >
        <div
          class="text-h4 font-weight-bold"
          :style="{ color: item.color }"
        >
          {{ stats[item.key] || 0 }}
        </div>
        <div
          class="subtitle-1 mt-1"
          :style="{ color: item.color }"
        >
          {{ $t(item.i18nKey) }}
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'DealerStatsCards',

  props: {
    stats: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    items: [
      {
        key: 'Nuovo',
        bg: '#e3f2fd',
        color: '#1565c0',
        i18nKey: 'dealer.dashboard.stats.nuovo',
      },
      {
        key: 'InElaborazione',
        bg: '#fff3e0',
        color: '#e65100',
        i18nKey: 'dealer.dashboard.stats.inElaborazione',
      },
      {
        key: 'Spedito',
        bg: '#e8f5e9',
        color: '#2e7d32',
        i18nKey: 'dealer.dashboard.stats.spedito',
      },
      {
        key: 'Completato',
        bg: '#f3e5f5',
        color: '#6a1b9a',
        i18nKey: 'dealer.dashboard.stats.completato',
      },
    ],
  }),
};
</script>
